(function () {
    const translations = {
        en: {
            standardDiscount: 'Standard discount'
        },
        nl: {
            standardDiscount: 'Standaard korting'
        },
        de: {
            standardDiscount: 'Standardrabatt'
        },
        fr: {
            standardDiscount: 'Remise standard'
        },
        it: {
            standardDiscount: 'Sconto standard'
        },
        sv: {
            standardDiscount: 'Standardrabatt'
        }
    };

    function getCurrentLanguage() {
        let lang = (typeof Shopify !== 'undefined' && Shopify.locale) ? Shopify.locale : null;
        if (!lang) {
            const urlParams = new URLSearchParams(window.location.search);
            lang = urlParams.get('locale') || 'en';
        }
        if (!translations[lang]) lang = 'en';
        return lang;
    }

    function translateDiscountLabels() {
        const lang = getCurrentLanguage();
        const t = translations[lang];

        // Translate line-item discount labels
        const lineItemDiscounts = document.querySelectorAll('ul.line-item__discount-list li.line-item__discount');
        lineItemDiscounts.forEach(item => {
            item.childNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) {
                    const text = node.nodeValue.trim();
                    if (text.includes('Standard discount') || text.includes('Standaard korting')) {
                        node.nodeValue = node.nodeValue.replace(/Standard discount|Standaard korting/gi, t.standardDiscount);
                    }
                }
            });
        });

        // Translate mini-cart discount labels
        const miniCartDiscounts = document.querySelectorAll('ul.mini-cart__discount-list li.mini-cart__discount');
        miniCartDiscounts.forEach(item => {
            item.childNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) {
                    const text = node.nodeValue.trim();
                    if (text.includes('Standard discount') || text.includes('Standaard korting')) {
                        node.nodeValue = node.nodeValue.replace(/Standard discount|Standaard korting/gi, t.standardDiscount);
                    }
                }
            });
        });
    }

    const observer = new MutationObserver((mutations, obs) => {
        const lineItemExists = document.querySelector('ul.line-item__discount-list li.line-item__discount');
        const miniCartExists = document.querySelector('ul.mini-cart__discount-list li.mini-cart__discount');
        
        if (lineItemExists || miniCartExists) {
            translateDiscountLabels();
            obs.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    setTimeout(() => {
        translateDiscountLabels();
    }, 2000);
    
    // Extra check after longer time in case elements load slowly
    setTimeout(() => {
        translateDiscountLabels();
        observer.disconnect();
    }, 5000);
})();